import {debounce} from 'lodash';

export interface TutorialTexts {
  title: string;
  content: string;
}

const INDEX = [
  'campaigns',
  'traffic-sources',
  'affiliate-networks',
  'offers',
  'landings'
];

export default (ctx: any) => ({
  start(page: string) {
    const cb = () => {
      ctx.bus.emit('reload-report');
      ctx.$helpers.afterBrowserRedraw(() => {
        ctx.$store.commit('quickStartStep', page);
      });
    };

    const link = ctx.getLink(page, {
      isReport: false
    });

    ctx.$router.push(link, cb, cb);
  },

  reset() {
    ctx.$store.commit('quickStartStep', 0)
  },

  close() {
    ctx.$intro().exit();
    ctx.$store.commit('quickStartStep', 0);
    ctx.$store.commit('quickStartHiddenClass', false);
  },

  texts: {
    'campaigns': {
      title: ctx.t('Campaign Settings'),
      content: ctx.t('Click \'New\' to set up a new campaign'),
    },
    'traffic-sources': {
      title: ctx.t('Traffic Source Settings'),
      content: ctx.t('Click \'New\' to add a new traffic source element'),
    },
    'affiliate-networks': {
      title: ctx.t('Affiliate Network Settings'),
      content: ctx.t('Click \'New\' to add a new affiliate network element'),
    },
    'offers': {
      title: ctx.t('Offer Settings'),
      content: ctx.t('Click \'New\' to add a new offer element'),
    },
    'landings': {
      title: ctx.t('Landing Page Settings'),
      content: ctx.t('Click \'New\' to add a new landing page'),
    }
  } as {[type: string]: TutorialTexts},

  firstStep: function(value: any) {
    if (INDEX.indexOf(value) === -1)
      return;

    ctx.$store.commit('quickStartSection', value);
      
    const intro = `<div class="introjs-tooltip__title">${this.texts[value].title}</div><div class="introjs-tooltip__content">${this.texts[value].content}</div>`;
    const options = {
      'exitOnEsc': false,
      'exitOnOverlayClick': false,
      'showStepNumbers': false,
      'hidePrev': true,
      'hideNext': true,
      'skipLabel': ctx.t('End tour'),
      'buttonClass': 'introjs-button introjs-button--hide',
      'showBullets': false
    };
    const entry: HTMLElement | null = document.querySelector('.tutorial-first-step');

    ctx.$intro()
      .addSteps([{element: entry, intro}])
      .setOptions(options)
      .start()
      .onexit((() => {
        ctx.$store.commit('quickStartStep', 0);
      }) as any);

  },

  modal: debounce(() => {
    ctx.$intro().exit();
    ctx.$store.commit('quickStartStep', 'modal');
  }),

  form: debounce(() => {
    if (!ctx.$store.state.tutorial.quickStart || ctx.$store.state.tutorial.quickStartStep !== 'modal')
      return;

    ctx.$store.commit('quickStartHiddenClass', true);
    const options = {
      'exitOnEsc': false,
      'exitOnOverlayClick': false,
      'showStepNumbers': false,
      'hidePrev': true,
      'hideNext': true,
      'skipLabel': ctx.t('End tour'),
      'nextLabel': ctx.t('Next »'),
      'prevLabel': ctx.t('« Prev'),
      'doneLabel': ctx.t('End tour'),
      'showBullets': false
    };

    const introInstance = ctx.$intro();

    introInstance
      .setOptions(options)
      .goToStepNumber(2)
      .start()
      .onbeforechange(() => {
        let continueStep = true;

        ctx.bus.emit('intro-js-onbeforechange', introInstance, (data: any) => {
          continueStep = data;
        });

        return continueStep;
      })
      .onexit((() => {
        ctx.$store.commit('quickStartStep', 0);
        ctx.$store.commit('quickStartHiddenClass', false);
      }) as any);

  }, 100),
});
